import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';

import ReservationActions from '@/actions/ReservationActions';

import ReservationDetails from './ReservationDetails';
import Travelers from './Travelers';
import TermsOfSupplier from './TermsOfSupplier';

import { ReactComponent as CheckmarkIcon } from '@/img/confirmation_page/checkmark.svg';
import ExpediaDealDetailsContainer from '../reservation-payment/components/ExpediaDealDetailsContainer.react';
import PriceSummary from '../reservation-payment/components/PriceSummary.react';

const ConfirmationPage = ({ reservation, hotel, profile, couponValidation, points }) => {
	const navigate = useNavigate();
	const { t, i18n } = useTranslation();

	const { supplier_ref: supplierRef, id, short_id: shortId, travelers, deal } = reservation;
	const nonRefundable = _.get(reservation, 'deal.dca.nonRefundable');
	const multiLanguageTexts = _.get(reservation, 'deal.original.dca.cancellationPoliciesMultiLanguageTexts');
	const defaultText = _.get(reservation, 'deal.original.dca.cancellationPoliciesText');
	const cancellationPoliciesText = (multiLanguageTexts ? multiLanguageTexts[i18n.language] : defaultText)?.split(
		'\n',
	);
	const city = _.get(hotel, 'city');
	const itineraryId = (supplierRef ? `${supplierRef}` : '').split('-')[0];

	useEffect(() => {
		window.scrollTo(0, 0);

		return () => {
			ReservationActions.clearReservation();
		};
	}, []);

	// var PHONE = t('SupportPhoneNumber');

	return (
		<div className="confirmation-page">
			<div className="order-confirmation">
				<div className="order-confirmation__title">{t('OrderConfirmation')}</div>
				{shortId && city && (
					<div className="order-confirmation__content">
						<CheckmarkIcon />
						<div className="order-confirmation__text">
							{t('ReservationProcessing', { id: itineraryId ? itineraryId : shortId, city: city })}
						</div>
					</div>
				)}
			</div>
			<div className="confirmation-page__content">
				<div className="confirmation-page__main">
					<Travelers travelers={travelers} bookingId={id} />

					<div className="cancellation-terms">
						<div className="cancellation-terms__content">
							<div className="title">{t('CancellationTerms')}</div>
							<div className="cancellation-terms__text">
								{cancellationPoliciesText.map((line, index) => (
									<div
										key={index}
										className={`cancellation-terms__${
											index === 0 ? (nonRefundable ? 'text-red' : 'text-green') : 'term'
										}`}
									>
										{line.trim()}
									</div>
								))}
							</div>
						</div>
						<div>
							<button
								className="confirmation-page__button"
								onClick={() => navigate('/bookings', { state: { id: id }, replace: true })}
							>
								{t('ViewYourBooking')}
							</button>
						</div>
					</div>

					<TermsOfSupplier deal={deal} />

					<div className="contact-us">
						<div className="contact-us__content">
							<div className="title">{t('ContactUs')}</div>
							<div className="contact-us__text">
								{t('ContactUsMessage')}
							</div>
						</div>
						<button
							className="confirmation-page__button"
							onClick={() => navigate('/contact-us')}
						>
							{t('ContactUs')}
						</button>
					</div>
				</div>

			<div className="confirmation-page__side">
				<ReservationDetails hotel={hotel} reservation={reservation} />
				{reservation.deal?.expedia_pricing ? (
					<ExpediaDealDetailsContainer profile={profile} reservation={reservation} isConfirmation={true} />
				) : (
					<PriceSummary
						reservation={reservation}
						profile={profile}
						hotel={hotel}
						couponValidation={couponValidation}
						points={points}
						hideTermsOfSupplierDisclaimer={true}
						isConfirmation={true}
					/>
				)}
			</div>
			</div>
		</div>
	);
};

export default ConfirmationPage;
